// extracted by mini-css-extract-plugin
export var changeIcon = "_5r-4";
export var container = "_5r-0";
export var divider = "_5r-7";
export var externalLinkIcon = "_5r-1";
export var green = "_5r-5";
export var helpCircleIcon = "_5r-3";
export var iconButton = "_5r-2";
export var red = "_5r-6";